module.exports = __webpack_public_path__ + "img/goldregen-2020-126.57db2e59.jpg";